document.addEventListener("DOMContentLoaded", function () {
  const printerHandle = new URLSearchParams(window.location.search).get("id");

  const selectedPrinter = window.printerData.find(
    (p) => p.handle === printerHandle
  );

  if (selectedPrinter) {
    document.querySelector(".heading").textContent = selectedPrinter.name;
    if (selectedPrinter.rip) {
      document.querySelector(".sub-heading").textContent =
        selectedPrinter.name + " - " + selectedPrinter.rip;
    } else {
      document.querySelector(".sub-heading").textContent = selectedPrinter.name;
    }
    document.querySelector(".printer_image").src = `${selectedPrinter.image}`;

    if (selectedPrinter.ink) {
      document.querySelector(".printer-ink").textContent =
        "Ink Set " + selectedPrinter.ink;
    }

    const suggestedHTML =
      selectedPrinter.suggested_products.length > 0
        ? selectedPrinter.suggested_products
            .map(
              (product) => `
            <li class="product-title body-1">
              <a class="prod-variant-link" href="${product.url}" target="_blank" rel="noopener">${product.title}</a>
            </li>`
            )
            .join("")
        : `<li class="product-title body-1">No suggested Product</li>`;

    document.querySelectorAll(".products_suggestions").forEach((container) => {
      if (selectedPrinter.suggested_products.length > 0) {
        container.style.display = "";
      } else {
        container.style.display = "none";
      }
    });

    document
      .querySelectorAll(".products-variants-container")
      .forEach((container) => {
        container.innerHTML = suggestedHTML;
      });
  }

  // PREFILL AND SUBMIT HANDLER FOR POWERFUL FORM BUILDER (Globo)
  const FORM_ID = "144595";

  function waitForGloboForm(callback) {
    const poll = setInterval(() => {
      const formContainer = document.querySelector(
        `#globo-formbuilder-${FORM_ID}`
      );
      const formEl = formContainer
        ? formContainer.querySelector(`form[data-id="${FORM_ID}"]`)
        : null;
      // Wait until the form exists AND is visible (Globo removes display:none after init)
      if (formEl && getComputedStyle(formEl).display !== "none") {
        clearInterval(poll);
        // Small delay to ensure Globo has fully finished its field initialization
        setTimeout(() => callback(formContainer, formEl), 800);
      }
    }, 200);
  }

  waitForGloboForm(function (formContainer, formEl) {
    // Helper to set input value and trigger events
    function setAndTriggerInput(inputEl, value) {
      if (!inputEl || !value) return;
      inputEl.value = value;
      inputEl.dispatchEvent(new Event("input", { bubbles: true }));
      inputEl.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Prefill logic extracted into a function for retrying
    function prefillFields() {
      // Prefill customer data
      if (isLogin && customerData) {
        const companyField = document.getElementById(`${FORM_ID}-text-2`);
        setAndTriggerInput(companyField, customerData.company);
      }

      // Prefill printer data
      if (selectedPrinter) {
        const printerField = document.getElementById(`${FORM_ID}-text-5`);
        setAndTriggerInput(printerField, selectedPrinter.name);

        const ripField = document.getElementById(`${FORM_ID}-text-4`);
        setAndTriggerInput(ripField, selectedPrinter.rip);

        const inkField = document.getElementById(`${FORM_ID}-text-3`);
        setAndTriggerInput(inkField, selectedPrinter.ink);
      }

      // Auto-check the T&C consent checkbox
      const consent2 = document.getElementById(`${FORM_ID}-consent-2`);
      if (consent2 && !consent2.checked) {
        consent2.checked = true;
        consent2.dispatchEvent(new Event("input", { bubbles: true }));
        consent2.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // Initial prefill
    prefillFields();

    // Retry prefill if Globo clears values (up to 5 retries over ~2.5s)
    let retries = 0;
    const maxRetries = 5;
    const retryInterval = setInterval(() => {
      retries++;
      const printerField = document.getElementById(`${FORM_ID}-text-5`);
      // If the field exists but got cleared, re-apply
      if (printerField && selectedPrinter && printerField.value !== selectedPrinter.name) {
        prefillFields();
      }
      if (retries >= maxRetries) {
        clearInterval(retryInterval);
      }
    }, 500);

    // Watch for success message to show download button
    const successSelector = `.message.success`;
    let downloadShown = false;

    function showDownloadButton() {
      if (downloadShown) return;
      const downloadButton = document.querySelector(".download_Link");
      if (downloadButton && selectedPrinter) {
        const downloadUrl = `${selectedPrinter.pdf}`;
        const fileName = downloadUrl.split("/").pop().split("?")[0];
        downloadButton.href = downloadUrl;
        downloadButton.download = fileName;
        downloadButton.style.display = "block";
      }
      downloadShown = true;
    }

    function checkSuccess() {
      const successMsgs = formContainer.querySelectorAll(successSelector);
      for (const msg of successMsgs) {
        if (
          msg &&
          getComputedStyle(msg).display !== "none" &&
          msg.closest("form") === null
        ) {
          // The success message outside the form (display:block) indicates submission
          showDownloadButton();
          return true;
        }
      }
      return false;
    }

    // MutationObserver to detect when success message appears
    const observer = new MutationObserver(() => {
      if (checkSuccess()) {
        observer.disconnect();
        clearInterval(pollingCheck);
      }
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    // Polling fallback
    const pollingCheck = setInterval(() => {
      if (checkSuccess()) {
        observer.disconnect();
        clearInterval(pollingCheck);
      }
    }, 500);
  });
});